/**
 * API to load, save & delete user time and geography information
 * This includes user location, timezone and user language
 */
window.TimeGeographyAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    // Default caching for this API
    _protected.CACHING_TIMEOUT = 3 * 1000; // ms

    var promises = [];
    // Hold a flag of whether the API is still pending response from the server or not (already requesting)
    var isBeingLoaded = false;

    /**
     * Load user time and geography information
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.load = function () {
        var deferred = $q.defer();

        if (_protected.getCached(0)) {
            deferred.resolve(_protected.getCached(0));
            return deferred.promise;
        }
        else if (isBeingLoaded) {
            promises.push(deferred);
            return deferred.promise;
        }
        else {
            isBeingLoaded = true;
            promises.push(deferred);

            _protected.request('user/time_geography', 'GET').then(function(res) {
                isBeingLoaded = false;
                _protected.cache(0, res.data.data);

                promises.forEach(function(deferred) {
                    deferred.resolve(res.data.data);
                });

                promises = [];

            }, function (err) {
                isBeingLoaded = false;
                promises.forEach(function(deferred) {
                    deferred.reject(err);
                });

                promises = [];
            });

            return deferred.promise;
        }
    };

    /**
     * Save time geography API information
     * @param data
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.save = function (data) {
        var deferred = $q.defer();

        _protected.request('user/time_geography', 'POST', data).then(function(res) {
            deferred.resolve(res);
        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    }

    /**
     * Delete a specific user location
     * @param locationId
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.deleteLocation = function (locationId) {
        var deferred = $q.defer();

        _protected.request('user_location/delete/' + locationId, 'GET').then(function(res) {
            deferred.resolve(res);
        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    }

    /**
     * Return the primary location in the given time geography data loaded from same API
     * @param timeGeographyData
     * @returns {*}
     */
    self.findPrimaryLocation = function(timeGeographyData) {
        timeGeographyData.user_location = timeGeographyData.user_location || [];
        // Default to first or null
        var primaryLocation = timeGeographyData.user_location[0];

        for (var i in timeGeographyData.user_location) {
            if (timeGeographyData.user_location[i].is_primary) {
                primaryLocation = timeGeographyData.user_location[i];
            }
        }

        return primaryLocation;
    }

    /**
     * Replace primary location in given time geography data loaded from same API and save the change
     * @param timeGeographyData
     * @param newPrimary
     * @returns {*}
     */
    self.replacePrimaryLocation = function(timeGeographyData, newPrimary) {
        var oldPrimary = self.findPrimaryLocation(timeGeographyData) || {};
        timeGeographyData = { user_location: [] }

        if (!oldPrimary.id || oldPrimary.id != newPrimary.id) {

            if (oldPrimary.id) {
                // The location completely, delete the old one
                TimeGeographyAPI.deleteLocation(oldPrimary.id);
            }

            timeGeographyData.user_location.push({
                "is_primary" : true,
                "google_location": newPrimary && newPrimary.value
            });

        }
        else {
            // If primary location is still the same, save it any way - this is to verify the location for the backend
            timeGeographyData.user_location.push({
                "is_primary" : true,
                "location_id": oldPrimary.id
            })
        }

        return TimeGeographyAPI.save(timeGeographyData);
    }
});